module.exports = __webpack_public_path__ + "media/images/flags/mz-28b723aaa5044eaa57d0e361772cd921.svg";